import NewStatusPicker from 'crqlar-react-common/dist/components/NewStatusPicker';
import {useTranslation} from 'react-i18next';

/** 'saved' = one of the organisation's audiences; 'new' = built here and written on Save. */
export type AudienceChoice = 'saved' | 'new';

/** The dialog stores the choice as an opaque string; anything but 'new' (incl. '') opens on Use audience. */
export const readAudienceChoice = (value?: string): AudienceChoice => (value === 'new' ? 'new' : 'saved');

interface AudienceModePickerProps {
    value?: string;
    onChange?: (choice: AudienceChoice) => void;
    disabled?: boolean;
}

const AudienceModePicker = ({value, onChange, disabled}: AudienceModePickerProps) => {
    const {t} = useTranslation();

    return (
        <NewStatusPicker<AudienceChoice>
            value={readAudienceChoice(value)}
            disabled={disabled || !onChange}
            ariaLabel={t('Audience')}
            onChange={next => onChange?.(next)}
            options={[
                {value: 'saved', label: t('Use audience')},
                {value: 'new', label: t('Create audience')}
            ]}
        />
    );
};

export default AudienceModePicker;
